import React from 'react';
import { Check } from 'lucide-react';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function PaintCorrectionPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Minor Paint Correction',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Professional minor paint correction and polishing to remove swirl marks, scratches, and oxidation, restoring a mirror-like finish.'
  };
  return <ServicePageLayout title="Minor Paint Correction in Los Angeles & Ventura County" subtitle="Erase years of wear and tear. Our machine polishing process removes swirl marks, scratches, and oxidation to restore a flawless, mirror-like finish." metaDescription="Expert minor paint correction and polishing in Camarillo, Thousand Oaks, and Ventura County. Remove swirl marks and scratches. Call (818) 381-9905." schema={schema} data-id="element-561">
      <p data-id="element-562">
        Does your car's paint look dull, faded, or covered in a web of fine
        scratches when the sun hits it? These imperfections are known as swirl
        marks, and they are typically caused by improper washing techniques,
        automated car washes, and environmental wear. At Mike's Pro Detail, our{' '}
        <strong data-id="element-563">Minor Paint Correction</strong> service utilizes advanced
        machine polishing techniques to permanently remove these defects,
        restoring clarity, depth, and a brilliant shine to your vehicle's
        finish. We provide this specialized mobile service throughout Camarillo
        CA, Thousand Oaks, and Ventura County.
      </p>

      <h2 data-id="element-564">What is Minor Paint Correction?</h2>
      <p data-id="element-565">
        Minor paint correction is the mechanical process of leveling the clear
        coat of a vehicle's paintwork to remove sub-surface defects. Unlike
        waxes or glazes that simply "fill in" or hide scratches temporarily,
        minor paint correction permanently removes them by safely shaving down
        microscopic layers of the clear coat until the surface is perfectly flat
        and reflective.
      </p>

      <h2 data-id="element-566">Defects We Can Remove:</h2>

      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-567">
        <li className="flex items-start" data-id="element-568">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-569" />
          <span data-id="element-570">
            <strong data-id="element-571">Swirl Marks & Spider Webbing:</strong> The circular
            micro-scratches most visible under direct sunlight or streetlights.
          </span>
        </li>
        <li className="flex items-start" data-id="element-572">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-573" />
          <span data-id="element-574">
            <strong data-id="element-575">Light to Medium Scratches:</strong> Scratches that have not
            penetrated entirely through the clear coat down to the base color.
          </span>
        </li>
        <li className="flex items-start" data-id="element-576">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-577" />
          <span data-id="element-578">
            <strong data-id="element-579">Water Spots & Etching:</strong> Mineral deposits from hard
            water or acid rain that have baked into the surface.
          </span>
        </li>
        <li className="flex items-start" data-id="element-580">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-581" />
          <span data-id="element-582">
            <strong data-id="element-583">Oxidation & Fading:</strong> The cloudy, chalky appearance
            caused by prolonged UV exposure and lack of protection.
          </span>
        </li>
        <li className="flex items-start" data-id="element-584">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-585" />
          <span data-id="element-586">
            <strong data-id="element-587">Buffer Trails & Holograms:</strong> Marks left behind by
            inexperienced detailers using rotary polishers incorrectly.
          </span>
        </li>
      </ul>

      <h2 data-id="element-588">Our Multi-Stage Process</h2>
      <p data-id="element-589">
        Depending on the condition of your paint and your desired results, we
        offer different levels of correction. A <strong data-id="element-590">One-Step Polish</strong>{' '}
        is great for newer cars or those needing a light enhancement, removing
        about 50-60% of defects while significantly boosting gloss. A{' '}
        <strong data-id="element-591">Two-Step Correction</strong> involves a heavy compounding stage
        to remove deeper scratches, followed by a refining polish to restore
        maximum clarity, removing 85-95% of defects. Every minor paint
        correction service begins with a thorough wash, iron decontamination,
        and clay bar treatment to ensure the paint is surgically clean before
        polishing begins.
      </p>

      <h2 data-id="element-592">The Best Mobile Detailing Ventura County Has to Offer</h2>
      <p data-id="element-593">
        Minor paint correction is an art that requires the right combination of
        machines, pads, compounds, and technique. Doing it wrong can burn
        through the clear coat and cause irreversible damage. When searching for
        "Mobile Auto Detailing Camarillo CA" or "Car Detailing Camarillo" for
        high-end paint restoration, trust the expertise of Mike's Pro Detail. We
        highly recommend pairing our minor paint correction service with a
        Ceramic Coating to lock in that flawless finish for years to come.
      </p>
    </ServicePageLayout>;
}